<template>
    <div class="page_content" aria-label="Enroll Student Page Content">
		<div class="row page-heading mx-0">
			<div class="col-8 input module_heading" role="heading" aria-level="1">
				<span class="module_icon icon-course"></span>
				<span class="module_type_name">Group Name :: {{ title }}</span>
			</div>
			<div class="col-4 submit btn-container text-right">
				<button type="button" class="btn btn-primary" @click="saveAndDone" aria-label="save & done">save & done</button>
				<button type="button" class="btn btn-primary" @click="cancel" aria-label="cancel">cancel</button>
			</div>
		</div>

        <b-container fluid class="facets-search-grid-container">
            <b-row>
                <div class="facets facets-role-col col-3">
                    <div class="search-row">
                        <input type="text" class="input-search" placeholder="search user" @input="searchUser" aria-label="search user" v-model.trim="searchTerm">
                        <div class="clear-btn" v-if="this.searchTerm.length > 0" @click="searchUser">
							<b-btn @click="searchTerm = ''" aria-label="clear">X</b-btn>
						</div>
                    </div>
                    <div class="main_head">
                        <span class="head_txt">Narrow Your Results</span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="head">
                                <div class="head_txt">Role</div>
                            </div>

                            <div class="facet_row_container">
                                <b-form-group aria-label="select user role">
                                    <b-form-checkbox-group plain stacked v-model="selectedRoles" aria-label="users role list" :options="userRoles" @input="getUsersForRole" />
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="facets facets-user-col col-4">
                    <div class="main_head">
                        <span class="head_txt">Students</span>
                        <span class="float-right">
                            <button type="button" class="btn btn-primary" @click="enrollUsers" aria-label="enroll" :disabled="(selectedUsers.length === 0)">enroll</button>
                        </span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <template v-if="shouldShowNoResultFound">
                                    <span class="no-result">No results found!</span>
                                </template>
                                <template v-else>
                                    <b-form-group aria-label="selected users">
                                        <b-form-checkbox-group plain stacked v-model="selectedUsers" @input="changeSelectedUsers" aria-label="selected users list">
                                            <template v-for="user in userList">
                                                <b-form-checkbox :value="user" :disabled="user.special" :class="{'special': user.special}" ><span class="check-description">{{ user.title }}</span></b-form-checkbox>
                                            </template>
                                        </b-form-checkbox-group>
                                    </b-form-group>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="facets facets-enrolledUser-col col-4">
                    <div class="main_head">
                        <span class="head_txt">Enrolled Students</span>
                        <span class="float-right">
                            <span @click="deleteEnrolledUsers" :class="{'icon-bin': true, 'action-link': (selectedEnrolledUsers.length > 0)}" :disabled="(selectedEnrolledUsers.length === 0)" aria-label="delete" tabindex="0"></span>
                        </span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <b-form-group aria-label="selected enrolled users">
                                    <b-form-checkbox-group plain stacked v-model="selectedEnrolledUsers" @input="changeSelectedEnrolledUsers" aria-label="selected enrolled users list">
                                        <template v-for="enrolledUser in enrolledUserList">
                                            <b-form-checkbox :value="enrolledUser" v-if="enrolledUser.show" :disabled="enrolledUser.disabled"><span class="check-description">{{ enrolledUser.title }}</span></b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>
        </b-container>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import '../../../assets/module/less/folder-management.less'

export default {
  name: 'groupDetail',
  props: ['uuid'],
  data () {
    return {
      title: '',
      description: '',
      consumerKey: '',
      sharedSecret: '',
      type: 'ByURL',
      launchURL: '',
      toolIconUrl: '',
      typeOptions: ['ByURL', 'Manual'],
      pageSize: 100,
      users: [],
      userList: [],
      enrolledUserList: [],
      selectedUsers: [],
      selectedEnrolledUsers: [],
      userRoles: ['Student'],
      selectedRoles: ['Student'],
      actionType: {ENROLL: 'ENROLL', UNENROLL: 'UNENROLL'},
      searchTerm: '',
      shouldShowNoResultFound: false
    }
  },

  computed: {

  },

  async mounted () {
    return this.loadGroup()
  },

  methods: {
    ...mapActions([
      'createGroup',
      'loadGroupDetail',
      'loadUsersForRole'
    ]),

    async loadGroup () {
      let response = await this.loadGroupDetail(this.uuid)
      this.title = response.name || ''
      this.userUuidList = response.userUuidList || []
    },

    searchUser () {
      this.refreshList()
    },

    refreshList () {
      this.userList = []
      this.getUsersForRole()
    },

    getUsersForRole () {
      let roles = this.getSelectedRoles()
      let searchString = $.trim(this.searchTerm)
      let name = (searchString.length === 0) ? undefined : searchString
      this.fetchUsersForRole(roles, this.currentInstitutionId, 0, this.pageSize, name)
    },

    getSelectedRoles () {
      let roleString = ''
      let roles = this.selectedRoles
      for (let i = 0; i < roles.length; i++) {
        roleString += roles[i]
        if (i < (roles.length - 1)) {
          roleString += '|'
        }
      }
      return roleString
    },

    fetchUsersForRole (role, parentSpaceId, page, pageSize, name) {
      let data = {
        role: role,
        parentSpaceId: parentSpaceId,
        page: page,
        count: pageSize,
        name: name
      }
      this.loadUsersForRole(data).then(res => {
        this.userList = []
        $.each(res.content, (i, user) => {
          let result = {
            uuid: user.uuid,
            title: user.firstName + ' ' + user.lastName,
            roles: user.roles,
            isSelected: '',
            action: ''
          }
          this.userList.push(result)
        })
        if (this.userList.length > 0) {
          this.shouldShowNoResultFound = false
        } else {
          this.shouldShowNoResultFound = true
        }
      })
    },

    changeSelectedUsers () {
      $.each(this.userList, (i, entity) => {
        entity.isSelected = false
      })
      this.selectedUsers.forEach((user) => {
        user.isSelected = true
      })
    },

    changeSelectedEnrolledUsers () {
      this.selectedEnrolledUsers.forEach((user) => {
        user.isSelected = true
      })
    },

    enrollUsers () {
      // this.processEnrollAction(this.actionType.ENROLL)
      // this.selectedUsers = []
    },

    cancel () {
      this.$router.go(-1)
    },

    inputIsValid () {
      let title = this.title
      return title && title.length
    },

    async save () {
      this.$v.$touch()
      if (!this.inputIsValid()) {
        return this.notifyFailure('Error: \'Group Name\' cannot be blank')
      }
      this.$refs.loadingModal.show()
      let uuid = this.uuid || 0 // NOTE: KHUB interprets '0' as a new group
      let isUpdating = !!(uuid && uuid !== 0)
      let group = {
        name: this.title,
        userUuidList: this.userList || [],
        uuid: uuid
      }
      let response = await this.createGroup(group) // TODO
      if (!response) {
        let failure = 'Unable to' + (isUpdating ? ' update' : ' create') + ' Group ' + this.title
        return this.notifyFailure(failure)
      }
      let success = 'Group "' + this.title + (isUpdating ? '" updated' : '" created') + 'successfully.'
      this.notifySuccess(success)
      setTimeout(() => {
        this.$refs.loadingModal.hide()
        return this.$router.push({name: 'groupList'})
      }, 500)
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    }
  }
}
</script>

<style scoped>
  sup {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/app/group/components/GroupDetail.vue